module.exports = __webpack_public_path__ + "static/assets/fb415ad5942786875408478a005153c2.gif";